
export const tutorials = {
  'backoffice.sidebarUser.sections.tutorials.items.theClubRegistration': 'The Club Registrierung',

  // Tutorials Index Page
  'tutorials.index.title': 'Lernzentrum',
  'tutorials.index.subtitle': 'Schritt-für-Schritt-Anleitungen, um loszulegen',

  // Common
  'tutorials.common.downloadPdf': 'PDF-Leitfaden Herunterladen',
  'tutorials.common.pdfAlternative': 'Laden Sie unseren umfassenden PDF-Leitfaden herunter',
  'tutorials.common.watchVideo': 'Tutorial-Video Ansehen',
  'tutorials.common.pdfName': 'TheClub_Registrierungs_Leitfaden_DE.pdf',

  // Tutorial: Radex Markets Registration
  'tutorials.radexRegistration.title': 'Registrierung beim Radex Markets Broker',
  'tutorials.radexRegistration.description': 'Erfahren Sie, wie Sie Ihr Konto bei Radex Markets, dem regulierten Broker-Partner von TheClub, eröffnen und einrichten. Dieser Leitfaden behandelt Kontoerstellung, Dokumenteneinreichung und Identitätsverifizierung.',
  'tutorials.radexRegistration.links.registration': 'Radex Markets Registrierung',

  // Tutorial: Wire Transfer
  'tutorials.wireTransfer.title': 'Kontofinanzierung per Banküberweisung',
  'tutorials.wireTransfer.description': 'Eine vollständige Anleitung zur Finanzierung Ihres Radex Markets-Kontos per Banküberweisung. Deckt Bankdaten, Verarbeitungszeiten und Bestätigungsschritte ab.',
  'tutorials.wireTransfer.links.login': 'Radex Markets Login',

  // Tutorial: Card Funding
  'tutorials.cardFunding.title': 'Kontofinanzierung per Kredit-/Debitkarte',
  'tutorials.cardFunding.description': 'Eine vollständige Anleitung zur Finanzierung Ihres Radex Markets-Kontos mit einer Visa- oder Mastercard-Kredit- oder Debitkarte. Schnell, sicher und in wenigen Minuten bereit.',
  'tutorials.cardFunding.links.login': 'Radex Markets Login',

  // Tutorial: PAMM Registration
  'tutorials.pammRegistration.title': 'Registrierung beim TheClub PAMM-Konto',
  'tutorials.pammRegistration.description': 'Erfahren Sie, wie Sie Ihr Radex Markets-Konto mit dem PAMM-System von TheClub verknüpfen, damit Ihre Gelder von unseren professionellen Tradern verwaltet werden.',
  'tutorials.pammRegistration.links.institutional': 'PAMM Account Institutionelles Trading',
  'tutorials.pammRegistration.links.spartan': 'PAMM Account Spartan AI Trading',
  'tutorials.pammRegistration.links.login': 'PAMM Account Login',

  // Tutorial: TheClub Account Creation
  'tutorials.theclubAccount.title': 'Das TheClub-Konto Erstellen',
  'tutorials.theclubAccount.description': 'Schritt-für-Schritt-Anweisungen zur Erstellung Ihres TheClub-Mitgliedschaftskontos — von der Registrierung auf der Plattform bis zum Abschluss der Zuordnung Ihres PAMM Account.',
  'tutorials.theclubAccount.links.registration': 'TheClub Registrierungsseite',
  'tutorials.theclubAccount.links.registrationNote': 'Verwende den Link deines Sponsors',
  'tutorials.theclubAccount.links.website': 'TheClub Website',
};
